import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Carousel from "./components/Carousel";
import Servicios from "./components/Servicios";
import Preguntas from "./components/preguntas";
import Contacto from "./components/contacto";
import QuienesSomos from "./pages/QuienesSomos";
import Recursos from "./pages/recursos";
import Socios from "./pages/socios";
import ServiciosPag from "./pages/servicios/serviciosPag";
import ContactoPag from "./pages/contactoPag";
import ServiciosGenerales from "./pages/servicios/serviciosPrincipales";
import ServiciosEspeciales from "./pages/servicios/serviciosEspecializados";
import ServiciosContables from "./pages/servicios/serviciosContables";
import Boletin from "./pages/Boletin/boletin";
import BoletinDetalle from "./pages/Boletin/boletinDetalle";

import LibroReclamaciones from "./pages/libroReclamaciones";
import { BoletinProvider } from "./context/BoletinContext";
import ScrollToTop from "./components/ScrollToTop";

function AppContent() {
  const location = useLocation();

  const hideNavbarFooter = location.pathname === "/libro_reclamaciones";

  return (
    <>
      {!hideNavbarFooter && <Navbar />}

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Carousel />
              <Servicios />
              <Preguntas />
              <Contacto />
            </>
          }
        />
        <Route path="/nosotros" element={<QuienesSomos />} />
        <Route path="/recursos" element={<Recursos />} />
        <Route path="/socios" element={<Socios />} />
        <Route path="/servicios" element={<ServiciosPag />} />
        <Route path="/contacto" element={<ContactoPag />} />
        <Route path="/servicios-generales" element={<ServiciosGenerales />} />
        <Route path="/servicios-especiales" element={<ServiciosEspeciales />} />
        <Route path="/servicios-contables" element={<ServiciosContables />} />
        <Route path="/libro_reclamaciones" element={<LibroReclamaciones />} />
        <Route path="/boletin" element={<Boletin />} />
        <Route path="/boletin/:id" element={<BoletinDetalle />} />
      </Routes>

      {!hideNavbarFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BoletinProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </BoletinProvider>
    </HelmetProvider>
  );
}

export default App;
